import React, { useState, useEffect } from 'react'

const QuickAdd = ({ exercise, sub, onAdd, last }) => {
  const [reps, setReps] = useState('')
  const [weight, setWeight] = useState('')
  const [sets, setSets] = useState('')
  const [time, setTime] = useState('')
  const [notes, setNotes] = useState('')
  const [primary, setPrimary] = useState('')

  useEffect(() => {
    setReps('')
    setWeight('')
    setSets('')
    setTime('')
    setNotes('')
    setPrimary('')
  }, [exercise?._id, sub?._id])

  const fields = sub?.fields || {}
  const show = {
    reps: fields.reps !== false,
    weight: fields.weight !== false,
    sets: fields.sets !== false,
    time: fields.time !== false,
    notes: fields.notes !== false,
    primary: fields.primary !== false,
  }

  const formatTimeInput = (value) => {
    // Remove any non-digit, non-colon, non-period characters
    let cleaned = value.replace(/[^0-9:.]/g, '')
    // debugger
    // Handle different input patterns
    if (cleaned.includes(':')) {
      // Format as MM:SS.mmm
      const parts = cleaned.split(':')
      if (parts.length >= 2) {
        const minutes = parts[0]
        let seconds = parts[1]
        
        // Handle milliseconds after period
        if (seconds.includes('.')) {
          const secParts = seconds.split('.')
          seconds = secParts[0].padStart(2, '0').slice(0, 2)
          const ms = secParts[1] ? secParts[1].slice(0, 3) : ''
          return `${minutes}:${seconds}.${ms}`
        } else {
          // seconds = seconds.padStart(2, '0').slice(0, 2)
          return `${minutes}:${seconds}`
        }
      } 
    } else {
        if(cleaned.includes('.')) {
          const res = cleaned.split('.')
          return res[0];
        }
      }
  }

  const handleTimeChange = (value) => {
    const formatted = formatTimeInput(value)
    setTime(formatted)
  }

  const handleAdd = () => {
    if (!exercise) return

    if (exercise.mode === 'cardio') {
      const payload = {
        type: 'cardio',
        metric: exercise.cardioMetric,
        value: primary ? Number(primary) : null,
        unit: exercise.unit || (exercise.cardioMetric === 'distance' ? 'm' : 'cals'),
        time: time || null,
        notes: notes || ''
      }
      
      const hasData = payload.value != null || payload.time || payload.notes
      if (!hasData) {
        alert('Add at least one field.')
        return
      }
      
      onAdd(payload)
      setPrimary('')
      setTime('')
      setNotes('')
      return
    }

    // Strength or workout
    const payload = {
      type: exercise.mode === 'workout' ? 'workout' : 'strength',
      reps: reps ? Number(reps) : null,
      weight: weight ? Number(weight) : null,
      sets: sets ? Number(sets) : null,
      time: time || null,
      notes: notes || ''
    }
    
    const hasData = payload.reps != null || payload.weight != null || payload.sets != null || payload.time || payload.notes
    if (!hasData) {
      alert('Add at least one field.')
      return
    }
    
    onAdd(payload)
    setReps('')
    setWeight('')
    setSets('')
    setTime('')
    setNotes('')
  }

  return (
    <div className="quickadd">
      {exercise.mode === 'cardio' ? (
        <>
          {show.primary && (
            <div className="field">
              <label>{exercise.cardioMetric === 'distance' ? 'Distance' : 'Calories'}</label>
              <input 
                inputMode="decimal" 
                placeholder="0" 
                value={primary} 
                onChange={e => setPrimary(e.target.value)} 
              />
            </div>
          )}
          {show.time && (
            <div className="field">
              <label>Time</label>
              <input 
                placeholder="mm:ss.mmm" 
                value={time} 
                onChange={e => handleTimeChange(e.target.value)}
                title="Enter time as minutes:seconds.milliseconds (e.g., 5:30.500)"
              />
            </div>
          )}
          {show.notes && (
            <div className="field grow">
              <label>Notes</label>
              <input 
                placeholder="Add notes..." 
                value={notes} 
                onChange={e => setNotes(e.target.value)} 
              />
            </div>
          )}
          <button className="btn" onClick={handleAdd}>ADD</button>
        </>
      ) : (
        <>
          {show.reps && (
            <div className="field">
              <label>Reps</label>
              <input 
                inputMode="numeric" 
                placeholder="0" 
                value={reps} 
                onChange={e => setReps(e.target.value)} 
              />
            </div>
          )}
          {show.weight && (
            <div className="field">
              <label>Weight ({exercise.unit || 'lbs'})</label>
              <input 
                inputMode="decimal" 
                placeholder="0" 
                value={weight} 
                onChange={e => setWeight(e.target.value)} 
              />
            </div>
          )}
          {show.sets && (
            <div className="field">
              <label>Sets</label>
              <input 
                inputMode="numeric" 
                placeholder="0" 
                value={sets} 
                onChange={e => setSets(e.target.value)} 
              />
            </div>
          )}
          {show.time && (
            <div className="field">
              <label>Time</label>
              <input 
                placeholder="mm:ss.mmm" 
                value={time} 
                onChange={e => handleTimeChange(e.target.value)}
                title="Enter time as minutes:seconds.milliseconds (e.g., 5:30.500)"
              />
            </div>
          )}
          {show.notes && (
            <div className="field grow">
              <label>Notes</label>
              <input 
                placeholder="Add notes..." 
                value={notes} 
                onChange={e => setNotes(e.target.value)} 
              />
            </div>
          )}
          <button className="btn" onClick={handleAdd}>ADD</button>
        </>
      )}
    </div>
  )
}

export default QuickAdd
